var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-footer"},[_c('div',{staticClass:"organization"},[_vm._v(_vm._s(_vm.foo.organization['ru'])+" © "+_vm._s(_vm.getYear))]),_c('div',{staticClass:"feedback"},[_c('router-link',{attrs:{"to":"/feedback"}},[_vm._v(_vm._s(_vm.feedback[_vm.lang]))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }